<!-- 专题视频-->
<template>
    <div class="special-sub-box" v-if="showSpecial">
        <div class="special-sub-bg"></div>
        <div class="special-sub-content">
            <div class="special-sub-title">专题片</div>
            <div class="special-sub-center">
                <div class="special-sub-item first" @click="showVideo('829d0322537d4a909c6f282f8d95c02a')"></div>
                <div class="special-sub-item second" @click="showVideo('108a76e8d4574aa4a8a6321d4ee1ed67')"></div>
            </div>
            <div class="special-sub-close" @click="handleClose"></div>
        </div>
        <videoHotspot class="special-sub-video"  v-if="videoShow"  @closeVideo="closeVideo" :guid="guid"></videoHotspot>
    </div>
</template>
  
<script>
 import videoHotspot from "@/components/videoHotspot";

export default {
    name: 'canwser',
    components: {
        videoHotspot
    },
    props:{
        showSpecial:false
    },
    data() {
        return {
            guid:"",
            videoShow:false,
            audioState:""
        }
    },
    methods: {
         handleClose(){
        
            this.$emit("closeSpecialSub")
         },
          // 关闭讲解视频事件
        closeVideo() {
       
            this.videoShow = false;
            var audio = document.querySelector("#audio");
            if (audio.paused && sessionStorage.bgmusic == "play" && sessionStorage.bgmusicEnd == "false") {
                audio.play();
                audio.addEventListener("ended",function(){
            sessionStorage.bgmusicEnd = "true"
          })
            }
        },
        showVideo(guid) {
            this.guid = guid;
            this.videoShow = true;
            var audio = document.querySelector("#audio");

            if (audio.paused) {
            } else {
                audio.pause();
            }
        },
    },

}
</script>
  
<style lang="scss" scoped>
@mixin background-com {
    background-repeat: no-repeat;
    background-size: 100% 100%;
}
.special-sub-box{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10000000;
  .special-sub-bg{
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.56);
    @include background-com();
    position: absolute;
    left: 0;
    top: 0;
  }
  .special-sub-content{
    width: 960px;
    height: 540px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -270px;
    margin-left: -480px;
 
    .special-sub-title{
        font-size: 42px;
        text-align: center;
        height: 50px;
        width: 100%;
        line-height: 50px;
        position: absolute;
        top: -70px;
        color: #fff;
    }
    .special-sub-center{
       @include background-com();
       background-image: url("../assets/img/special-sub-bg.png");
       width: 100%;
       height: 100%;
       display: flex;
       align-items: center;
       justify-content: center;
       .special-sub-item{
        width: 374px;
        height: 234px;
        @include background-com();
        cursor: pointer;
        margin-bottom: 40px;
         &.first{
            margin-right: 50px;
            background-image: url("../assets/img/fjxsd1.png");
         }
         &.second{
            background-image: url("../assets/img/fjxsd2.png");
         }
       }
    }
    .special-sub-close{
        width: 42px;
        height: 42px;
        background: url('~@/assets/img/answer/answer-close-btn.png') no-repeat center;
        background-size: cover;
        position: absolute;
        top: -50px;
        right: -78px;
        cursor: pointer;
    }
  }
}
</style>